var Codec = require('io/codec');
var ByteEncodedEnumSerialiser = require('serialisers/byte-encoded-enum-serialiser');

var CommandError = require('./command-error');

var serialiser = {
    read : function(input) {
        var message = Codec.readString(input);
        var type = ByteEncodedEnumSerialiser.read(input, CommandError.ErrorType);
        
        return new CommandError(type, message);         
    },
    write : function(out, error) {
        Codec.writeString(out, error.message);
        ByteEncodedEnumSerialiser.write(out, error.type);
    }
};

module.exports = serialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/command-error-serialiser.js
// module id = 1055
// module chunks = 1